export default "__VITE_ASSET__125701c9__"